import './FileInput.css'
import { Input } from "@mui/material";
import React, {
    useEffect,
    useState,
    useRef,
    forwardRef,
    useImperativeHandle
} from "react";
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';

const FileInput = forwardRef(
    ({ selectedFile = [], setSelectedFile, accept='*', multiple }, ref) => {

        const [multipleDisplay, setMultipleDisplay] = useState([])
        const inputRef = useRef(null)
        const wrapperRef = useRef(null)

        useImperativeHandle(ref, () => ({
            focus: () => {
                wrapperRef.current?.focus()
            }
        }))

        const handleFileChange = (event) => {
            const files = Array.from(event.target.files)
            if (multiple) {
                setSelectedFile(files)
                setMultipleDisplay(files.map(file => file.name))
            } else {
                setSelectedFile(files[0])
            }
        }

        const handlePaste = (event) => {
            const items = event.clipboardData?.items
            if (!items) return

            let pastedFiles = []

            for (let item of items) {
                if (item.type.startsWith("image/")) {
                    const blob = item.getAsFile()
                    const file = new File(
                        [blob],
                        `imagem-colada-${Date.now()}.png`,
                        { type: blob.type }
                    )
                    pastedFiles.push(file)
                }
            }

            if (!pastedFiles.length) return

            if (multiple) {
                const filesArray = [...selectedFile, ...pastedFiles]
                setSelectedFile(filesArray)
                setMultipleDisplay(filesArray.map(file => file.name))

                const dataTransfer = new DataTransfer()
                filesArray.forEach(file => dataTransfer.items.add(file))
                inputRef.current.files = dataTransfer.files
            } else {
                setSelectedFile(pastedFiles[0])
            }
        }

        const removeFile = (index) => {
            const updatedFiles = selectedFile.filter((_, i) => i !== index)

            setSelectedFile(updatedFiles)
            setMultipleDisplay(updatedFiles.map(file => file.name))

            const dataTransfer = new DataTransfer()
            updatedFiles.forEach(file => dataTransfer.items.add(file))
            inputRef.current.files = dataTransfer.files
        }


        useEffect(() => {
            if (multiple && selectedFile.length < 1)
                setMultipleDisplay([])
        }, [selectedFile, multiple])

        return (
            <div
                id='div-input-file'
                ref={wrapperRef}
                onPaste={handlePaste}
                tabIndex={0}
            >
                {/* BOTÃO REAL */}
                <div
                    id="input-file"
                    onClick={(e) => {
                        e.stopPropagation()
                        inputRef.current?.click()
                    }}
                    style={{ cursor: 'pointer' }}
                >
                    <CreateNewFolderIcon fontSize="medium" />&nbsp;
                    Importar arquivo{multiple && '(s)'} (Ctrl + V)
                </div>

                <Input
                    type="file"
                    onChange={handleFileChange}
                    inputProps={{ accept, multiple }}
                    hidden
                    inputRef={inputRef}
                />

                {(multiple && selectedFile.length > 0) || (!multiple && selectedFile) ? (
                    <p>
                        {multiple
                            ? <>Selecionado(s):<br/><br/>
                                {multipleDisplay.map((name, index) => (
                                    <div
                                        key={name}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: '10px',
                                            marginBottom: '4px'
                                        }}
                                    >
                                        <span>{name}</span>

                                        <button
                                            type="button"
                                            onClick={() => removeFile(index)}
                                            style={{
                                                border: 'none',
                                                background: 'transparent',
                                                cursor: 'pointer',
                                                color: '#d32f2f',
                                                fontWeight: 'bold'
                                            }}
                                            title="Remover arquivo"
                                        >
                                            ✕
                                        </button>
                                    </div>
                                ))}

                            </>
                            : <>Selecionado: {selectedFile?.name}</>
                        }
                    </p>
                ) : (
                    <p>Nenhum arquivo selecionado</p>
                )}
            </div>
        )
    }
)

export default FileInput
